export function getFormData(){
    return fetch('/api/CustomerContact/GetEmarsysChoiceData')
        .then(function(response){
            return response.json();
        })
        .then(function(response){
            return {
                ...response,
                content: format(response.content)
            };
        });
}

export function getContent(){
    return fetch('/api/CustomerContact/EmailSignUp').then(r => r.text());
}

export function format(content){
    return (content || []).reduce(function(obj, item){
        var key = item.section.substring(0, 1).toLowerCase() + item.section.substring(1);
        if(!obj[key]){
            obj[key] = [];
        }

        obj[key].push(item);

        return obj;
    }, {});
}